import React, {useState, useEffect} from 'react'
import logo from '../images/logo.png'
import { Link } from 'react-router-dom';

import waves from '../images/waves.png'
import useWalletConnect from "../hooks/useWalletConnect";
import { useUser } from "../context/UserContext";
const InnerHeader = () =>{

    const [isOpen, setIsOpen] = useState(false);
     const [isScrolled, setIsScrolled] = useState(false);

    const { logout } = useUser();
     
       // Detect scroll position
       useEffect(() => {
         const handleScroll = () => {
           setIsScrolled(window.scrollY > 50); // If scrolled more than 50px, add background
         };
         
         window.addEventListener("scroll", handleScroll);
         return () => window.removeEventListener("scroll", handleScroll);
       }, []);

       

    const {
      account, disconnectWallet
  } = useWalletConnect();


       function trimAddress(address, length = 4) {
        if (!address) return '';
        return `${address.slice(0, 2 + length)}...${address.slice(-length)}`;
      }


    return (
        <header>
        <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? "bg-secondary-100 shadow-lg" : "bg-transparent"}`}>
          <div className="container mx-auto flex justify-between items-center p-4">
            {/* Logo */}
            <Link to="/" className="text-2xl font-bold text-primary font-psemibold"><img src={logo} className="w-[150px]"/></Link>
             <div onClick={disconnectWallet} className="bg-primary-100 pl-1 py-1 mb-4 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInUp">
                                        
            <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                            <i className="fa fa-check-circle text-secondary-100"></i></div>
                                        <div className="font-pregular text-[11px] mr-5 ml-2">
                                            {trimAddress(account?.address)}
                                        </div>
                                        </div>
            {/* Mobile Menu Button */}
            <button className="text-white" onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <i className="fa fa-times"></i>: <i className="fa fa-bars"></i>}
            </button>
          </div>
    
          </nav>
          {/* Mobile Menu */}
          <div className={`${isOpen ? "block" : "hidden"} shadow bg-secondary-100 w-70 sm:w-[50%] md:w-[35%] lg:w-[25%] fixed h-full`} style={{zIndex:'50'}}>
            
                       
                            <div className='px-10 lg:py-20 w-[100%]'>
                              <div className='text-center mb-10'>
                              <img src={logo} className="w-[150px]"/>
                              </div>
            <ul className="flex flex-col text-xs space-y-4 pb-10 font-pmedium  w-full">
            <li className='bg-secondary p-3  py-3 rounded w-full'><Link to="/"className="hover:text-black-100 text-sm mb-5"><i className='fa fa-home'></i> <span className='ml-3'>Home</span> </Link></li>
            <li className='bg-secondary p-3  py-2 rounded w-full'><Link to="/dashboard"className="hover:text-black-100 text-sm mb-5"><i className='fa fa-user'></i> <span className='ml-3'>Dashboard</span> </Link></li>
            <li className='bg-secondary p-3  py-2 rounded w-full'><Link to="/slots"className="hover:text-black-100 text-sm mb-5"><i className='fa fa-cubes'></i> <span className='ml-3'>Active Slots</span> </Link></li>
            <li className='bg-secondary p-3  py-2 rounded w-full'><Link to="/lottery"className="hover:text-black-100 text-sm mb-5"><i className='fa fa-chart-line'></i> <span className='ml-3'>Lottery Program</span> </Link></li>
            <li className='bg-secondary p-3  py-2 rounded w-full'><a href="#" onClick={()=>alert('Coming Soon')} className="hover:text-black-100 text-sm mb-5"><i className='fa fa-chart-line'></i> <span className='ml-3'>Salary Program</span> </a></li>
            <li className='bg-secondary p-3  py-2 rounded w-full'><a href="https://t.me/MarkManPro_OfficialChanel" target="_blank" className="hover:text-black-100 text-sm mb-5"><i className='fas fa-headset'></i> <span className='ml-3'>Support</span> </a></li>
            
            <li className='bg-secondary p-3  py-2 rounded w-full'><a href="#" onClick={logout} className="hover:text-black-100 text-sm mb-5"><i className='fas fa-sign-out-alt'></i> <span className='ml-3'>Logout</span> </a></li>
            </ul>
            </div>
            <div className="absolute opacity-10">
                                <img src={waves} className="w-[800px] float"/>
                            </div>
          </div>
        
        </header>
    )
}

export default InnerHeader;